import { useAuth } from './useAuth';
import { useState, useEffect } from 'react';

function useTableHeight() {
  const [tableScrollY, setTableScrollY] = useState(0);
  const { onBehalfOfUser } = useAuth();

  const updateTableHeight = () => {
    const tableContainer = document.querySelector('.ant-table-wrapper');
    if (tableContainer) {
      const offsetTop = tableContainer.getBoundingClientRect().top;
      const availableHeight = window.innerHeight - offsetTop - 70;
      setTableScrollY(availableHeight);
    }
  };

  /**
   * Update the table height when the user is on behalf of another user
   */
  useEffect(() => {
    updateTableHeight();

    window.addEventListener('resize', updateTableHeight);

    let observer: ResizeObserver | null = null;
    const tableContainer = document.querySelector('.ant-table-wrapper');
    if (tableContainer) {
      observer = new ResizeObserver(() => {
        updateTableHeight();
      });
      observer.observe(tableContainer);
    }

    // Clean up the event listener
    return () => {
      window.removeEventListener('resize', updateTableHeight);
      if (observer && tableContainer) {
        observer.unobserve(tableContainer);
      }
    };
  }, [onBehalfOfUser]);

  return {
    tableScrollY,
  };
}

export default useTableHeight;
